/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

// this is autogenerated file, see scripts/gen-version.js
export const VERSIONS = {
	pkgVersion: "1.313.6",
	prereleaseTag: "20250522-130604",
	fullVersion: "1.313.6.20250522-130604",
	buildDate: "2025.05.22 13:06:04",
	commitHash: "7b35583b0f09867d568efc7631facf982f735311",
	isDevVersion: false
};
